export default __webpack_public_path__ + "static/media/circle-scatter-haikei.f57936fb.svg";